import React, { useState } from 'react';

import capitalize from 'lodash/capitalize';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import Radio from 'zignal-landscape/lib/Radio';
import Label from 'zignal-landscape/lib/Label';
import MfeModal from '../../../../components/MfeModal/MfeModal';

import { TWITTER_SUBTYPE_OPTIONS, MEDIA_OPTIONS } from '../../helpers';

const AdditionalFilters = ({
  styles,
  index = 0,
  settings = {},
  updateAdditionalFilters,
  closeAdditonalFilters
}) => {
  const { open } = settings;
  const [ stateSettings, setStateSettings ] = useState(cloneDeep(settings));
  const { filters={} } = stateSettings;
  const {
    twitterContent=TWITTER_SUBTYPE_OPTIONS, mediaChecked=false,
    mediaOption='0', excludeUSChecked=false
  } = filters;

  const updateContent = ({target={}}) => {
    const { name } = target;
    const newFilters = cloneDeep(filters);
    newFilters.twitterContent = newFilters.twitterContent || TWITTER_SUBTYPE_OPTIONS.slice();
    if (newFilters.twitterContent.includes(name)) {
      newFilters.twitterContent = newFilters.twitterContent.filter((option) => option !== name);
    } else {
      newFilters.twitterContent.push(name);
    }
    setStateSettings({...settings, filters: newFilters});
  };
  const updateCheckbox = ({target={}}) => {
    const { name, checked } = target;
    const newFilters = cloneDeep(filters);
    newFilters[name] = checked;
    setStateSettings({...settings, filters: newFilters});
  };
  const updateMediaOption = ({target={}}) => {
    const { name } = target;
    const newFilters = cloneDeep(filters);
    newFilters.mediaOption = name;
    newFilters.mediaChecked = true;
    setStateSettings({...settings, filters: newFilters});
  };
  return (
    <MfeModal
      isOpen={open}
      size="small"
      onBackdropClick={closeAdditonalFilters}
    >
      <div className={styles.AdditionalFilters}>
        <div className={styles.top}>
          <div className={styles.title}>Additional Filters</div>
          <div className={styles.twitterContent}>
            <div className={styles.subheader}>Twitter Content</div>
            {TWITTER_SUBTYPE_OPTIONS.map((subtype) => (
              <React.Fragment key={subtype}>
                <Checkbox
                  id={subtype}
                  name={subtype}
                  checked={twitterContent.includes(subtype)}
                  onChange={updateContent}
                />
                <Label
                  htmlFor={subtype}
                  inline
                >
                  {capitalize(subtype)}
                </Label>
                <br />
              </React.Fragment>
            ))}
          </div>
          <div className={styles.media}>
            <div className={styles.subheader}>Media and Location</div>
            <Checkbox
              id="mediaChecked"
              name="mediaChecked"
              checked={mediaChecked}
              onChange={updateCheckbox}
            />
            <Label
              htmlFor="mediaChecked"
              inline
            >
              Filter by media present
            </Label>
            <div className={styles.mediaOptions}>
              {MEDIA_OPTIONS.map((text, i) => (
                <React.Fragment key={text}>
                  <Radio
                    id={`media${i}`}
                    name={i}
                    checked={mediaChecked && mediaOption == i}
                    onChange={updateMediaOption}
                  />
                  <Label htmlFor={`media${i}`} inline>{text}</Label>
                  <br />
                </React.Fragment>
              ))}
            </div>
            <Checkbox
              id="excludeUSChecked"
              name="excludeUSChecked"
              checked={excludeUSChecked}
              onChange={updateCheckbox}
            />
            <Label
              htmlFor="excludeUSChecked"
              inline
            >
              Exclude content from the US
            </Label>
          </div>
        </div>
        <div className={styles.footer}>
          <button className={styles.cancelButton} onClick={closeAdditonalFilters}>Cancel</button>
          <button
            className={styles.doneButton}
            onClick={() => updateAdditionalFilters({...stateSettings, open: false}, index)}
          >
            Done
          </button>
        </div>
      </div>
    </MfeModal>
  );
};

AdditionalFilters.propTypes = {
  styles: PropTypes.object,
  index: PropTypes.number,
  settings: PropTypes.object,
  updateAdditionalFilters: PropTypes.func,
  closeAdditonalFilters: PropTypes.func,
};

export default themeable(AdditionalFilters);
